import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'bmcore-download-icon',
  templateUrl: './bmcore-download-icon.component.html',
  styleUrls: ['./bmcore-download-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreDownloadIconComponent {
  @Input() fillColor = 'currentColor'
  @Input() width = 24
  @Input() height = 24
}
